import React, { createContext, useContext, useState, ReactNode } from 'react';
import Alert from '../components/Alert';

interface AlertState {
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
}

interface AlertContextType {
  showAlert: (alert: AlertState) => void;
  hideAlert: () => void;
}

const AlertContext = createContext<AlertContextType | undefined>(undefined);

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (context === undefined) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
};

interface AlertProviderProps {
  children: ReactNode;
}

export const AlertProvider: React.FC<AlertProviderProps> = ({ children }) => {
  const [alert, setAlert] = useState<AlertState | null>(null);

  const showAlert = (alertState: AlertState) => {
    setAlert(alertState);
  };

  const hideAlert = () => {
    setAlert(null);
  };

  return (
    <AlertContext.Provider value={{ showAlert, hideAlert }}>
      {children}
      {alert && (
        <div style={{
          position: 'fixed',
          top: '80px',
          right: '20px',
          zIndex: 9999,
          maxWidth: '400px',
        }}>
          <Alert
            type={alert.type}
            message={alert.message}
            onClose={hideAlert}
            autoClose
            duration={5000}
          />
        </div>
      )}
    </AlertContext.Provider>
  );
};

